"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
const jsx_runtime_1 = require("react/jsx-runtime");
const react_router_dom_1 = require("react-router-dom");
const common_styled_components_1 = require("../../common-styled-components");
const YearContext_1 = require("../../../contexts/YearContext");
const useFetch_1 = __importDefault(require("../../../hooks/useFetch"));
const react_1 = require("react");
const log_1 = require("../../../util/log");
const apiUtils_1 = require("../../../util/apiUtils");
const useDeepMemo_1 = require("../../../hooks/useDeepMemo");
const ShipTable_1 = require("../common/tables/ShipTable");
const useMetadata_1 = require("../../../hooks/useMetadata");
const TransactionStatistics_1 = require("../common/TransactionStatistics");
const NumberKPI_1 = __importDefault(require("../common/NumberKPI"));
const theme_1 = require("../../../theme");
const PoolEOYReport = () => {
    const { selectedYear } = (0, YearContext_1.useYear)();
    const { poolId } = (0, react_router_dom_1.useParams)();
    const [pools, _setUrl, _setBody, _refresh] = (0, useFetch_1.default)("admin/pools.json", undefined, true);
    const [usageAnalysis, _setUsageUrl, _setUsageBody] = (0, useFetch_1.default)("admin/pool_fuel_usage.json", undefined, true);
    const [transactions, _setTransUrl, _setTransPostBody] = (0, useFetch_1.default)("admin/transactions.json", undefined, true);
    const [voyages, _setVoyagesUrl, _setVoyagesBody] = (0, useFetch_1.default)("admin/voyages.json", undefined, true);
    const [metadata] = (0, useMetadata_1.useMetadata)();
    (0, react_1.useEffect)(() => {
        _setBody(JSON.stringify({
            pool_id: Number(poolId),
            year: selectedYear,
        }));
        _setUsageBody(JSON.stringify({
            pool_id: Number(poolId),
            year: selectedYear,
        }));
        _setTransPostBody(JSON.stringify({
            pool_id: Number(poolId),
            year: selectedYear,
        }));
        _setVoyagesBody(JSON.stringify({
            pool_id: Number(poolId),
            year: selectedYear,
        }));
    }, [selectedYear, poolId]);
    const poolData = pools.status === apiUtils_1.LoaderStatus.Success ? pools.data[0] : undefined;
    const voyageData = voyages.status === apiUtils_1.LoaderStatus.Success ? voyages.data : [];
    const transactionsData = transactions.status === apiUtils_1.LoaderStatus.Success ? transactions.data : [];
    (0, log_1.log)([
        {
            label: "pool",
            content: poolData,
        },
        {
            label: "usageAnalysis",
            content: usageAnalysis,
        },
        {
            label: "transactions",
            content: transactions,
        },
        {
            label: "voyages",
            content: voyages,
        },
    ]);
    const [noVoyageShips, voyageAmount] = (0, useDeepMemo_1.useDeepMemo)(() => {
        if (poolData && voyageData) {
            const shipsWithVoyages = new Set();
            voyageData.forEach((voyage) => {
                shipsWithVoyages.add(voyage.ship_id);
            });
            const noVoyageShips = poolData.ships.filter((ship) => !shipsWithVoyages.has(ship.id));
            return [noVoyageShips, voyageData.length];
        }
        return [[], 0];
    }, [poolData, voyageData]);
    return poolData &&
        metadata &&
        voyageData.length &&
        transactionsData.length ? ((0, jsx_runtime_1.jsxs)(common_styled_components_1.PageContent, { align: "left", children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.ContentGrid, { "$cols": 1, children: (0, jsx_runtime_1.jsxs)(common_styled_components_1.SectionTitle, { children: [selectedYear, " End-of-year Report for ", poolData?.name] }) }), (0, jsx_runtime_1.jsxs)(common_styled_components_1.ContentGrid, { children: [(0, jsx_runtime_1.jsx)(common_styled_components_1.GridCard, { children: (0, jsx_runtime_1.jsx)(NumberKPI_1.default, { value: poolData?.ships.length || 0, title: "Ships", color: theme_1.theme.colors.darkBlue }) }), (0, jsx_runtime_1.jsx)(common_styled_components_1.GridCard, { children: (0, jsx_runtime_1.jsx)(NumberKPI_1.default, { value: voyageAmount, title: "Voyages", color: theme_1.theme.colors.darkBlue }) }), (0, jsx_runtime_1.jsx)(common_styled_components_1.GridCard, { children: (0, jsx_runtime_1.jsx)(NumberKPI_1.default, { value: transactionsData.length, title: "Transactions", color: theme_1.theme.colors.darkBlue }) })] }), transactionsData.length && ((0, jsx_runtime_1.jsx)(TransactionStatistics_1.TransactionStatistics, { transactions: transactionsData, year: selectedYear })), (0, jsx_runtime_1.jsx)(common_styled_components_1.ContentGrid, { "$cols": 1, children: (0, jsx_runtime_1.jsxs)(common_styled_components_1.GridCard, { children: [(0, jsx_runtime_1.jsxs)(common_styled_components_1.SmallTitle, { children: ["No-Voyage Ships: ", noVoyageShips.length] }), noVoyageShips?.length ? ((0, jsx_runtime_1.jsx)(ShipTable_1.ShipTable, { ships: noVoyageShips, metadata: metadata, year: selectedYear })) : null] }) })] })) : ((0, jsx_runtime_1.jsx)(common_styled_components_1.PageContent, { align: "left", children: "Loading..." }));
};
exports.default = PoolEOYReport;
